import Enterprise from '@/datatypes/enterprise';

export default class Application {
  public id: string;
  public name: string;
  public description: string;
  public scopes: Array<string>;
  public redirectUri: Array<string>;
  public approvedAt: undefined | string;
  public rejectedAt: undefined | string;
  public rejectionReason: undefined | string;
  public disabledAt: string;
  public uid: string;
  public createdAt: string;
  public updatedAt: string;
  public status: string;
  public enterprise: Enterprise;

  constructor(options) {
    this.id = options.id;
    this.uid = options.uid;
    this.name = options.name;
    this.description = options.description;
    if (typeof options.scopes === 'string') {
      this.scopes = options.scopes.split(' ');
    } else {
      this.scopes = options.scopes;
    }
    if (typeof options.redirectUri === 'string') {
      this.redirectUri = options.redirectUri.split('\n');
    } else {
      this.redirectUri = options.redirectUri;
    }
    this.createdAt = options.createdAt;
    this.updatedAt = options.updatedAt;
    this.approvedAt = options.approvedAt;
    this.rejectedAt = options.rejectedAt;
    this.rejectionReason = options.rejectionReason;
    this.disabledAt = options.disabledAt;
    this.status = options.status;
    this.enterprise = options.enterprise || new Enterprise({});
  }

  public allScopes = ['standard', 'read_only'];
}
